import MainScript from './main.js'
//
import ItemsList from './../Components/ItemsManagement/index.vue';
import DesktopView from './desktop/desktop.vue';

// let service = new services();
export default {
    name: 'MManageItems',
    mixins: [MainScript],
    data () {
        return {}
    },
  
    components: {
        //
        'component-items': ItemsList,
        'component-desktop':DesktopView
    },
  
    methods: {},
    created: function(){}
}


// WEBPACK FOOTER //
// ./src/pages/ManageItems/script.js